<template>
  <div class="staff">
    <section class="main">
      <div class="t_pic_box">
        <img class="t_pic" src="../assets/img/staff/banner4.jpg" alt />
      </div>
      <div class="bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>员工风采</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 员工风采 -->
      <div class="develop">
        <div class="d_tit">
          <div class="top_title">
            <div class="title1">
              STAFF
              <br />STYLE
            </div>
            <div class="title2">员工风采</div>
          </div>
        </div>
        <div class="d_list">
          <div class="demo-image__preview" v-for="(item,index) in srcList" :key="index">
            <el-image :src="item.url" :preview-src-list="pre_srcList"></el-image>
            <div class="name">{{item.name}}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      srcList: [
        { url: require("../assets/img/staff/photo1.jpg"), name: "年会" },
        // { url: require("../assets/img/staff/photo2.jpg"), name: "年会" },
        // { url: require("../assets/img/staff/photo3.jpg"), name: "年会" },
        { url: require("../assets/img/staff/photo4.jpg"), name: "趣味运动会" },
        { url: require("../assets/img/staff/photo5.jpg"), name: "趣味运动会" },
        { url: require("../assets/img/staff/photo6.jpg"), name: "沙漠拓展" },
        { url: require("../assets/img/staff/photo7.jpg"), name: "沙漠拓展" },
        { url: require("../assets/img/staff/photo8.jpg"), name: "徒步拓展" },
        { url: require("../assets/img/staff/photo9.jpg"), name: "植树公益活动" },
        { url: require("../assets/img/staff/photo10.jpg"), name: "员工团建" },
        { url: require("../assets/img/staff/photo11.jpg"), name: "员工团建" },
        { url: require("../assets/img/staff/photo12.jpg"), name: "员工团建" },
        { url: require("../assets/img/staff/photo13.jpg"), name: "爱心慈善行" },
        { url: require("../assets/img/staff/photo14.jpg"), name: "爱心慈善行" },
        { url: require("../assets/img/staff/photo15.jpg"), name: "团队培训" },
        { url: require("../assets/img/staff/photo16.jpg"), name: "团队培训" },
        // { url: require("../assets/img/staff/photo17.jpg"), name: "植树公益活动" }
      ],
      pre_srcList: [
        require("../assets/img/staff/photo1.jpg"),
        require("../assets/img/staff/photo2.jpg"),
        require("../assets/img/staff/photo3.jpg"),
        require("../assets/img/staff/photo4.jpg"),
        require("../assets/img/staff/photo5.jpg"),
        require("../assets/img/staff/photo6.jpg"),
        require("../assets/img/staff/photo7.jpg"),
        require("../assets/img/staff/photo8.jpg"),
        require("../assets/img/staff/photo9.jpg"),
        require("../assets/img/staff/photo10.jpg"),
        require("../assets/img/staff/photo11.jpg"),
        require("../assets/img/staff/photo12.jpg"),
        require("../assets/img/staff/photo13.jpg"),
        require("../assets/img/staff/photo14.jpg"),
        require("../assets/img/staff/photo15.jpg"),
        require("../assets/img/staff/photo16.jpg"),
        // require("../assets/img/staff/photo17.jpg"),
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.staff {
  .t_pic_box {
    font-size: 0;
  }
  .t_pic {
    width: 100%;
  }
  .develop {
    width: 1200px;
    margin: 80px auto;
    .top_title {
      position: relative;
      text-align: center;
      margin-bottom: 53px;
    }

    .top_title .title1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      font-family: 'HarmonyOS Sans SC';
      font-size: 60px;
      color: rgba(76, 1, 4, 0.05);
      line-height: 60px;
      text-align: center;
      font-weight: 400;
      margin-bottom: 6px;
    }

    .top_title .title2 {
      font-family: 'HarmonyOS Sans SC';
      font-size: 40px;
      color: #4c0104;
      text-align: center;
      font-weight: 500;
      width: 100%;
      margin-bottom: 85px;
      padding-top: 32px;
      position: relative;
      z-index: 1;
    }
    .d_list {
      display: grid;
      grid-template-columns: repeat(auto-fill, 285px);
      gap: 20px;
      .demo-image__preview {
        width: 100%;
        height: 190px;
        border-radius: 8px;
        position: relative;

        .name {
          position: absolute;
          left: 0;
          bottom: -1px;
          width: 100%;
          height: 32px;
          line-height: 32px;
          background: #ffe800;
          border-radius: 0 0 8px 8px;
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4c0104;
          transition: all 0.5s;
          opacity: 0;
        }
        &:hover .name {
          opacity: 1;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.staff .demo-image__preview .el-image {
  height: 190px;
}
.staff .demo-image__preview .el-image > img {
  width: 285px;
  height: 190px;
  border-radius: 8px;
}
</style>
